// Specifications transcribed from the user's 30-page Garg Kota Stone catalog.
// Unpublished measurements remain explicitly unconfirmed, never inferred from photos.
const photos = (name, captions) => captions.map((caption, i) => ({
  src: `/catalog/details/${name}-${i + 1}.jpg`, caption,
}));
const floorPhotos = (name) => photos(name, ["Flooring application", "Surface detail", "Entrance application"]);

export const FINISHES = [
  {
    id: "mirror-finish", name: "Mirror Finish", finish: "Mirror-polished flooring",
    material: "Natural Kota stone", tone: "Grey", size: '46″ × 22″', page: "08",
    description: "A smooth, reflective surface in a premium grey shade. Natural Kota stone brings an elegant, timeless finish to modern homes.",
    applications: "Residential flooring · Indoor & outdoor spaces",
    images: floorPhotos("mirror"), featured: true,
    cover: "/catalog/floor-mirror.jpg", span: "col-span-12 md:col-span-7",
  },
  {
    id: "blue-leather", name: "Kota Blue", finish: "Leather finish",
    material: "Natural Kota Blue stone", tone: "Blue-grey, naturally varied", size: '46″ × 22″', page: "11",
    description: "A subtly textured leather finish with natural colour variation. Kota Blue connects indoor and outdoor flooring with an understated, earthy character.",
    applications: "Indoor & outdoor flooring", images: floorPhotos("blue-leather"), featured: true,
    cover: "/catalog/floor-blue-leather.jpg", span: "col-span-12 md:col-span-5",
  },
  {
    id: "jaisalmer-yellow", name: "Jaisalmer Yellow", finish: "Mirror polish",
    material: "Natural Jaisalmer Yellow stone", tone: "Golden yellow", page: "14",
    description: "Rich golden tones and a smooth, reflective surface bring warmth to premium residential and commercial spaces.",
    applications: "Residential & commercial flooring",
    images: photos("jaisalmer", ["Polished stone slab", "Flooring application", "Surface close-up"]), featured: true,
    cover: "/catalog/floor-jaisalmer.jpg", span: "col-span-12 md:col-span-4",
  },
  {
    id: "hexagon-mix", name: "Hexagon Mix", finish: "Mirror-finish hexagon pattern",
    material: "Kota stone & Jaisalmer Yellow", tone: "Grey & golden yellow", page: "15",
    description: "An elegant hexagon composition pairing mirror-finish Kota stone with Jaisalmer Yellow. A natural combination of colour and geometry for modern interiors.",
    applications: "Interior flooring",
    images: photos("hexagon", ["Hexagon flooring application", "Stone edge detail", "Pattern detail"]), featured: true,
    cover: "/catalog/floor-hexagon.jpg", span: "col-span-12 md:col-span-4",
  },
  {
    id: "kota-yellow", name: "Kota Yellow", finish: "Leather finish",
    material: "Natural Kota Yellow stone", tone: "Warm yellow, naturally varied", size: "2′ × 2′", page: "10",
    description: "Warm, earthy stone with a leather-finished surface. Each piece carries natural colour variation, giving indoor and outdoor spaces their own character.",
    applications: "Indoor & outdoor flooring", images: floorPhotos("yellow-leather"), featured: true,
    cover: "/catalog/floor-yellow-mix.jpg", span: "col-span-12 md:col-span-4",
  },
  {
    id: "cobbles-paving", name: "Cobbles & Paving", finish: "Kota shot brush & basalt cobbles",
    material: "Kota stone & black basalt", tone: "Grey & black", size: 'Basalt cobbles: 4″ × 4″; Kota sizes on enquiry', page: "18–19",
    description: "Shot-brush Kota stone meets black basalt cobbles in an architectural paving composition. Square and hexagonal Kota patterns feature in the outdoor collection.",
    applications: "Driveways · Pathways · Outdoor spaces",
    images: photos("paving", ["Square Kota & basalt paving", "Kota surface detail", "Basalt cobble detail"]), featured: true,
    cover: "/catalog/paving-square.jpg", span: "col-span-12",
  },
  {
    id: "sada-polish", name: "Sada Polish", finish: "Smooth, non-reflective polish",
    material: "Natural Kota stone", tone: "Natural Kota tones", page: "07",
    thickness: "18–24 · 25–30 · 30–35 · 38–45 · 45–50 mm",
    description: "A smooth, non-reflective finish with a natural look. The catalog specifies five thickness ranges for practical, high-traffic flooring.",
    applications: "Courtyards · Pathways · Parking · Industrial flooring",
    images: photos("sada", ["Stone thickness selection", "Open-space application", "Industrial flooring"]),
  },
  {
    id: "satin-finish", name: "Satin Finish", finish: "Smooth matte finish",
    material: "Natural Kota stone", tone: "Natural grey", size: '46″ × 22″', page: "09",
    description: "A smooth matte surface with subtle natural texture. An elegant, understated alternative to mirror polish for modern homes.",
    applications: "Indoor & outdoor flooring", images: floorPhotos("satin"),
  },
  {
    id: "shot-blast", name: "Shot Blast", finish: "Rough, textured finish",
    material: "Natural Kota stone", tone: "Lighter grey", size: '46″ × 22″', page: "12",
    description: "A lighter shade and a rough, textured surface give this finish a distinct natural character. Listed as “Short Blast” in the catalog.",
    applications: "Indoor & outdoor flooring", images: floorPhotos("shot-blast"),
  },
  {
    id: "shot-brush", name: "Kota Blue Shot Brush", finish: "Shot-brush flooring",
    material: "Natural Kota Blue stone", tone: "Blue-grey, naturally varied", size: '46″ × 22″', page: "13",
    description: "Natural Kota Blue with a brushed surface and colour variation from piece to piece. Listed as “Short Brush” on the catalog flooring page.",
    applications: "Indoor & outdoor flooring", images: floorPhotos("shot-brush"),
  },
  {
    id: "geometric-pattern", name: "Geometric Pattern", finish: "Smooth mirror finish",
    material: "Natural Kota stone", tone: "Mixed natural Kota shades", page: "16",
    description: "A modern geometric arrangement of Kota stone in natural shades. Smooth mirror finishes highlight the stone's colour and the rhythm of the pattern.",
    applications: "Interior flooring",
    images: photos("geometric", ["Geometric flooring application", "Surface & edge detail", "Pattern detail"]),
  },
  {
    id: "herringbone-paving", name: "Herringbone Paving", finish: "Herringbone layout",
    material: "Natural Kota stone", tone: "Multi-colour natural shades", page: "20",
    description: "A classic herringbone pattern in multi-colour Kota stone. A timeless composition for walkways, entrances and outdoor spaces.",
    applications: "Walkways · Entrances · Outdoor spaces",
    images: photos("herringbone", ["Herringbone paving application", "Pattern detail", "Stone edge detail"]),
  },
  {
    id: "blue-cladding", name: "Kota Blue Cladding", finish: "Shot brush · Machine-cut edges",
    material: "Natural Kota Blue stone", tone: "Blue-grey", size: '46″ × 12″ · 22″ × 12″', page: "27",
    description: "Subtle texture and an elegant tone for contemporary architectural exteriors. Machine-cut edges give this natural stone cladding a clean finish.",
    applications: "House façades · Boundary walls · Exterior cladding",
    images: photos("blue-cladding", ["Exterior wall application", "Surface detail", "Machine-cut side angle"]),
  },
  {
    id: "black-rockface", name: "Black Rockface", finish: "Natural rockface texture",
    material: "Natural black basalt", tone: "Black", size: '12″ × 6″ · 24″ × 6″', page: "28",
    description: "Textured black basalt for contemporary façades, boundary walls and architectural exterior surfaces. A strong natural texture with a timeless dark tone.",
    applications: "House façades · Boundary walls · Exterior cladding",
    images: photos("black-rockface", ["Black rockface stone selection", "Surface detail", "Stone side angle"]),
  },
  {
    id: "mint-rockface", name: "Mint Rockface", finish: "Natural rockface texture",
    material: "Natural mint stone", tone: "Light mint", size: '12″ × 6″ · 24″ × 6″', page: "29",
    description: "A subtle light tone with natural texture and strong character, suited to contemporary façades and architectural exterior surfaces.",
    applications: "House façades · Boundary walls · Exterior cladding",
    images: photos("mint-rockface", ["Exterior wall application", "Surface detail", "Stone side angle"]),
  },
  {
    id: "basalt-cobbles", name: "Basalt Black Cobbles", finish: "Rugged rockface texture",
    material: "Natural basalt stone", tone: "Black", size: '4″ × 4″ (paving collection)', page: "18–19, 25",
    description: "Natural black basalt cobbles with a rugged rockface texture, bringing a modern, earthy character to landscape and outdoor paving.",
    applications: "Pathways · Driveways · Gardens · Courtyards",
    images: photos("basalt", ["Cobble paving application", "Front view", "Cobble detail"]),
  },
];

export const FEATURED_FINISHES = FINISHES.filter((finish) => finish.featured);